<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<div class="card">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="redirectSchoolFG()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <!-- PARTICIPANT INFO -->
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_church_name}}</span>
                    <span class="p-text-bold">{{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.schoolId+" "
                        +schoolFpgDetail.schoolFPG.name +" - "+
                        schoolFpgDetail.churchName :""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_workshop}}</span>
                    <span class="p-text-bold">{{schoolFpgDetail != null ? translations.lbl_school_prep_guides : ""}}
                    </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_schedule}}</span>
                    <span class="p-text-bold">{{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.fromTime : ""}} -
                        {{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.toTime : translations.lbl_pending}}</span>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- PARTICIPANT LIST -->
    <p-table #dt [value]="listParticipant" [rows]="10" [paginator]="true"
        [globalFilterFields]="['guide.lastName','guide.name','guide.mobPhon','guide.email','guideStatus']"
        [(selection)]="selectedParticipant" [rowHover]="true" dataKey="particiId"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" responsive="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{translations.lbl_future_guide}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>
            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-plus" (click)="redirectParticipantDetail(null)"
                    class="p-mr-4 z-5" pTooltip="{{translations.lbl_new_record}}" tooltipPosition="bottom"
                    [disabled]="schoolFpgDetail != null &&  (schoolFpgDetail.schoolFPG.status === 'C') ? true : false "></button>

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="guide.name">{{translations.lbl_id}} <p-sortIcon field="guide.name"></p-sortIcon>
                </th>
                <th pSortableColumn="guide.name">{{translations.lbl_name}} <p-sortIcon field="guide.name"></p-sortIcon>
                </th>
                <th pSortableColumn="guide.mobPhon">{{translations.lbl_cell_phone}} <p-sortIcon
                        field="guide.mobPhon"></p-sortIcon>
                </th>
                <th pSortableColumn="guide.email">{{translations.lbl_email}} <p-sortIcon
                        field="guide.email"></p-sortIcon></th>
                <th pSortableColumn="guideStatus">- <p-sortIcon field="guideStatus"></p-sortIcon></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{data.guide.guideId}} </td>
                <td>{{data.guide.name}} {{data.guide.lastName}}</td>
                <td>{{data.guide.mobPhon}} </td>
                <td style="white-space: normal; word-wrap: break-word;">{{data.guide.email}}</td>
                <td>{{data.guideStatus}}</td>

                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        *ngIf="data.guide.guiType=='F' && data.guide.status!='B'"
                        (click)="redirectParticipantDetail(data)" pTooltip="{{translations.lbl_edit}}"></button>
                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2"
                        *ngIf="data.guide.guiType=='F' && data.guide.status!='B'  && (schoolFpgDetail != null &&  schoolFpgDetail.schoolFPG.status !== 'C' &&  schoolFpgDetail.schoolFPG.status !== 'D')"
                        (click)="deleteParticipant(data)" pTooltip="{{translations.lbl_delete}}"></button>

                    <button pButton pRipple icon="pi pi-check-circle" class="p-button-rounded p-button-success p-mr-2"
                        *ngIf="data.guide.guiType=='F' && (schoolFpgDetail != null &&  schoolFpgDetail.schoolFPG.status !== 'C')"
                        (click)="showDialogStatus(data)" pTooltip="{{translations.lbl_status}}"></button>

                    <button pButton pRipple icon="pi pi-send" class="p-button-rounded p-button-info"
                        *ngIf="data.guide.status!='B' && data.guide.guiType=='F'" (click)="showDialogGuide(data)"
                        pTooltip="{{translations.lbl_send}}"></button>

                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-secondary p-mr-2"
                        *ngIf="data.guide.status=='B'" (click)="openGuideFGDetail(data)"
                        pTooltip="{{translations.lbl_select}}"></button>

                    <!-- TRASPASO DE GUIA -->
                    <button pButton pRipple icon="pi pi-globe" class="p-button-rounded p-button-help p-mr-2"
                        *ngIf="data.guide.status!='B' && data.guide.guiType=='F'"
                        (click)="redirectoToParticipantTransfer(data)"
                        pTooltip="{{translations.lbl_movement + ' ' + translations.lbl_of + ' ' + translations.lbl_future_guide}}"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{listParticipant ? listParticipant.length : 0 }}
                {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</div>

<p-dialog header="{{translations.lbl_status}}" [(visible)]="displayModalStatus" styleClass="p-fluid" [modal]="true"
    [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_coordination}}</span>
                    <span class="p-text-bold">{{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.storeId +" -
                        "+schoolFpgDetail.storeName
                        :""}}</span>
                </div>
                <div class="subTitle  p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_guideId}}</span>
                    <span class="p-text-bold">{{participantSelected != null ? participantSelected.guide.guideId +" - "+
                        participantSelected.guide.name +" "+participantSelected.guide.lastName : ""}} </span>
                </div>
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_status}}</span>
                    <span class="p-text-bold">{{participantSelected != null ?participantSelected.guide.status : ""}}
                        -
                        {{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.toTime : translations.lbl_pending}}</span>
                </div>
                <!--<div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Periodo</span>
                    <span class="p-text-bold">{{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.year : ""}}</span>
                </div>-->

            </div>
        </div>
        <!-- INPUTS -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">

                <div class="p-fluid">
                    <!-- Estatus --> <!--TODO: FALTA ETIQUETA PARA CAMBIO DE ESTATUS-->
                    <div class="p-col-12">
                        <label for="statusModal">{{translations.lbl_leaving_reason}} <span *ngIf="!statusSelected"
                                style="color:red">(*)</span></label>
                        <p-dropdown id="statusModal" [options]="statusList" [(ngModel)]="statusSelected"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_leaving_reason}}"
                            optionLabel="value" [showClear]="true" (ngModelChange)="loadStatusChangesFG()"></p-dropdown>
                    </div>


                    <!-- Name -->
                    <div class="p-col-12">
                        <label for="dateModal">{{translations.lbl_date}} <span *ngIf="!dateSelected" style="color:red">
                                (*)</span></label>
                        <p-inputMask id="dateModal" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="dateSelected" placeholder="DD/MM/YYYY"></p-inputMask>

                    </div>

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="commentsModal">{{translations.lbl_comments}} <span *ngIf="!commentsSelected"
                                style="color:red">
                                (*)</span></label>
                        <textarea id="commentsModal" [(ngModel)]="commentsSelected" rows="5" cols="30" pInputTextarea
                            autoResize="autoResize" maxlength="300" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                    </div>


                    <!-- Historial de cambios-->
                    <div class="p-col-12">
                        <label for="labelAccordion">{{translations.lbl_history}}
                            {{translations.lbl_leaving_reason}}</label>
                        <p-accordion id="labelAccordion">
                            <ng-container *ngIf="fgChangesLog && fgChangesLog.length > 0; else noHistory">
                                <p-accordionTab *ngFor="let item of fgChangesLog" [header]="item.comments ">
                                    {{translations.lbl_id}} {{translations.lbl_guide}}: {{ (item.id.key1Id) }}<br />
                                    {{translations.lbl_date}} : {{ convertDateFormat(item.id.currDate) }}<br />
                                    {{translations.lbl_guide}} : {{ (item.id.fileId) }}
                                </p-accordionTab>
                            </ng-container>
                            <ng-template #noHistory>
                                <br /><br />
                                <p>{{translations.lbl_no}} {{translations.lbl_history}} {{translations.lbl_available}}
                                </p>
                            </ng-template>
                        </p-accordion>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">

        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalStatus=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            class="p-button-raised p-button-success" (click)="updateParticipantStatus()"></button>
    </ng-template>
</p-dialog>

<!-- TODO: FALTA ETIQUETA DE TITULO -->
<p-dialog header="{{translations.lbl_send}} {{translations.lbl_future_guide}}" [(visible)]="displayModalGuide"
    styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_coordination}}</span>
                    <span class="p-text-bold">{{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.storeId +" -
                        "+schoolFpgDetail.storeName
                        :""}}</span>
                </div>
                <div class="subTitle  p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_guideId}}</span>
                    <span class="p-text-bold">{{participantSelected != null ? participantSelected.guide.guideId +" - "+
                        participantSelected.guide.name +" "+participantSelected.guide.lastName : ""}} </span>
                </div>
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_status}}</span>
                    <span class="p-text-bold">{{participantSelected != null ?participantSelected.guide.status : ""}}
                        -
                        {{schoolFpgDetail != null ? schoolFpgDetail.schoolFPG.toTime : translations.lbl_pending}}</span>
                </div>
            </div>
        </div>
        <!-- INPUTS -->
        <div class="p-grid">
            <!-- 1ST SECTION INFO -->
            <div class="p-col-12">

                <div class="p-fluid">
                    <!-- Input DATE -->
                    <div class="p-col-12">
                        <label for="dateSentSelectedModal">{{translations.lbl_date}} <span *ngIf="!dateSentSelected"
                                style="color:red">
                                (*)</span></label>
                        <p-inputMask id="dateSentSelectedModal" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="dateSentSelected" placeholder="DD/MM/YYYY"></p-inputMask>

                    </div>


                    <!-- Input CERTIFIED -->
                    <div class="p-col-12">
                        <label for="certifiedSelectedModal">{{translations.lbl_certificate}} <span
                                *ngIf="!dateSentSelected" style="color:red">
                                (*)</span></label>
                        <input id="certifiedSelectedModal" [(ngModel)]="certifiedSelected" type="text" maxlength="10"
                            pInputText>
                    </div>

                    <div class="p-formgrid p-grid p-ai-center p-jc-center p-pt-1 p-py-3 ">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_commitment_letter}}</span>
                        </div>
                        <div class="p-col-12 p-md-8" style="text-align: center;">
                            <div class="p-d-flex p-ai-left p-jc-around ">
                                <p-radioButton label="{{translations.lbl_signed}}" name="groupname" value="1"
                                    [(ngModel)]="commLetter"></p-radioButton>
                                <p-radioButton label="{{translations.lbl_not_provided}}" name="groupname" value="0"
                                    [(ngModel)]="commLetter"></p-radioButton>
                            </div>
                        </div>
                    </div>

                    <!-- Comments -->
                    <div class="p-col-12">
                        <label for="commentsModal">{{translations.lbl_comments}} <span *ngIf="!commentsSentSelected"
                                style="color:red">
                                (*)</span></label>
                        <textarea id="commentsModal" [(ngModel)]="commentsSentSelected" rows="5" cols="30"
                            pInputTextarea autoResize="autoResize" maxlength="300" #myInput></textarea>
                        <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalGuide=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            class="p-button-raised p-button-success" (click)="updateParticipantGuide()"></button>
    </ng-template>
</p-dialog>